import { Group } from '../backend/backendapi';

export type GroupSelector<T> = ((t: T) => Group) | string;

export function applyGroupSelector<T>(obj: T, selector: GroupSelector<T>): Group {
  if (typeof (selector) === 'function') {
    return selector(obj);
  } else if (typeof (selector) === 'string') {
    selector = selector.trim();
    if (selector.length === 0) {
      return obj as Group;
    }
    const path = selector.split('.');
    let ret = obj as object;
    for (let part of path) {
      ret = ret[part];
    }
    return ret as Group;
  } else {
    throw new Error('Unknown selector type');
  }
}